<section class="benefit-perk">
  <div class="box-container">
    <div class="perk-topic">
      <!-- desktop heading-->
      <div
        class="perk-topic__heading perk-topic__heading--desktop color-gray"
        [innerHtml]="'WORK_WITH_US.PERK_SECTION.HEADING' | translate"
      >
      </div>

      <!-- tablet heading-->
      <div
        class="perk-topic__heading perk-topic__heading--tablet color-gray"
        [innerHtml]="'WORK_WITH_US.PERK_SECTION.HEADING' | translate"
      >
      </div>

      <!-- mobile heading -->
      <div
        class="perk-topic__heading perk-topic__heading--mobile color-gray"
        [innerHtml]="'WORK_WITH_US.PERK_SECTION.HEADING' | translate"
      >
      </div>
    </div>

    <div class="box">
      <ng-container *ngFor="let item of perkList">
        <div class="box__item">
          <picture>
            <source srcset="{{ item.imageWebP }}" type="image/webp" />
            <source srcset="{{ item.image }}" type="image/png" />
            <img src="{{ item.image }}" width="100%" loading="lazy" alt="{{ item.imageAlt }}" class="box__image" />
          </picture>
          <div class="box__item--text" [innerHtml]="item.text | translate"> </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
